<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.site.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.site.list.title"></app-i18n>
      </h1>

      <app-site-list-toolbar></app-site-list-toolbar>
      <app-site-list-filter></app-site-list-filter>
      <app-site-list-table></app-site-list-table>
    </div>
  </div>
</template>

<script>
import SiteListFilter from '@modules/site/components/site-list-filter.vue';
import SiteListTable from '@modules/site/components/site-list-table.vue';
import SiteListToolbar from '@modules/site/components/site-list-toolbar.vue';

export default {
  name: 'app-site-list-page',

  components: {
    [SiteListFilter.name]: SiteListFilter,
    [SiteListTable.name]: SiteListTable,
    [SiteListToolbar.name]: SiteListToolbar,
  },
};
</script>

<style>
</style>
